export function useGtmBB() {
	const info = useInfo();
	const storage = useLocalStorage();

	// referral
	function sendReferral(payload) {
		const data = {
			'event': 'referrer_data',
			'referrer': payload,
		};

		_pushToDataLayer(data);
	}

	function gtmTrack(event, payload, options = {}) {
		const data = {
			event: event,
			ecommerce: {},
		};
		const productExtraData = {};

		if(['virtualPageview'].includes(event)) {
			delete data.ecommerce;
			data.pageUrl = payload.url;
			data.pageTitle = payload.title;
		}
		
		if (['view_item_list'].includes(event)) {
			const selectItemListId = payload.item_list_id || payload.items?.[0].category_code || '';
			const selectItemListName = payload.item_list_name || payload.items?.[0].category_title || '';
			data.ecommerce.item_list_id = selectItemListId;
			data.ecommerce.item_list_name = selectItemListName;
			productExtraData.item_list_id = selectItemListId;
			productExtraData.item_list_name = selectItemListName;
		}

		if(['add_to_wishlist', 'view_item', 'add_to_cart', 'remove_from_cart'].includes(event)) {
			data.ecommerce.value = formatTotalPrice(payload);
			data.ecommerce.currency = 'EUR';
		}

		if(['add_to_cart'].includes(event)) {
			let selectItemListId = payload.item_list_id || payload.items.category_code || '';
			let selectItemListName = payload.item_list_name || payload.items.category_title || '';
			const selectItemSessionData = storage.get('gtm_select_item', {storage: 'session'});
			if(payload.mode != 'cart') {
				// Get select item list id and name from session storage
				if (selectItemSessionData) {
					selectItemListId = selectItemSessionData?.item_list_id;
					selectItemListName = selectItemSessionData?.item_list_name;
				}

				// Update cart items in localStorage. If item already exists, update it. If not, add it.
				storage.update('gtm_cart_items', {
					shopping_cart_code: payload.items.shopping_cart_code,
					item_list_id: selectItemListId,
					item_list_name: selectItemListName
				}, {condition: item => item.shopping_cart_code == payload.items.shopping_cart_code});
			} else {
				// If mode is 'cart', don't update item_list_id and item_list_name
				const cartItems = storage.get('gtm_cart_items', {condition: item => item.shopping_cart_code == payload.items.shopping_cart_code});
				if(cartItems?.length) {
					selectItemListId = cartItems[0]?.item_list_id;
					selectItemListName = cartItems[0]?.item_list_name;
				}
			}

			productExtraData.item_list_id = selectItemListId;
			productExtraData.item_list_name = selectItemListName;
			if(payload.quantity) productExtraData.quantity = payload.quantity;
			if(payload.index) productExtraData.index = payload.index;
		}

		if(['remove_from_cart'].includes(event)) {
			if(payload.quantity) productExtraData.quantity = payload.quantity;
			if(payload.index) productExtraData.index = payload.index;
			
			let selectItemListId = payload.item_list_id || payload.items.category_code || '';
			let selectItemListName = payload.item_list_name || payload.items.category_title || '';
			
			const storageItem = storage.get('gtm_cart_items', {condition: item => item.shopping_cart_code == payload.items.shopping_cart_code});
			if(storageItem?.length) {
				selectItemListId = storageItem[0]?.item_list_id;
				selectItemListName = storageItem[0]?.item_list_name;
			}

			productExtraData.item_list_id = selectItemListId;
			productExtraData.item_list_name = selectItemListName;

			if(!payload.total) {
				storage.remove('gtm_cart_items', {condition: item => item.shopping_cart_code == payload.items.shopping_cart_code});
			}
		}

		if(['add_to_wishlist'].includes(event)) {
			productExtraData.item_list_id = payload.item_list_id;
			productExtraData.item_list_name = payload.item_list_name;
		}

		if(['view_item'].includes(event)) {
			if (sessionStorage.getItem('gtm_select_item')) {
				const selectItemSessionData = JSON.parse(sessionStorage.getItem('gtm_select_item'));
				productExtraData.item_list_id = selectItemSessionData.item_list_id;
				productExtraData.item_list_name = selectItemSessionData.item_list_name;
			}
		}

		if(['select_item'].includes(event)) {
			let selectItemListId = payload.item_list_id || payload.items.category_code || '';
			let selectItemListName = payload.item_list_name || payload.items.category_title || '';
			data.ecommerce.item_list_id = selectItemListId;
			data.ecommerce.item_list_name = selectItemListName;
			productExtraData.item_list_id = selectItemListId;
			productExtraData.item_list_name = selectItemListName;
			
			// Save select item list data to session storage so we can use it in viewItem event
			if (payload?.item_list_id || payload?.item_list_name) {
				storage.create('gtm_select_item', {item_list_id: selectItemListId, item_list_name: selectItemListName}, {storage: 'session'});
			} else {
				storage.remove('gtm_select_item', {storage: 'session'});
			}
		}

		// Add coupon data
		if (['begin_checkout', 'add_shipping_info', 'add_payment_info'].includes(event)) {
			const coupon = payload.cart?.total?.extraitems?.find(el => el.type === 'coupon');
			data.ecommerce.coupon = coupon?.code || '';
			productExtraData.coupon = coupon?.code || '';
		}

		if(['view_cart', 'begin_checkout', 'add_shipping_info', 'add_payment_info', 'purchase'].includes(event)) {
			const cartProducts = getCartProducts(payload.cart);
			data.ecommerce.value = formatTotalPrice({items: cartProducts});
			data.ecommerce.currency = 'EUR';
			payload.items = cartProducts;
		}

		if(['add_shipping_info'].includes(event)) {
			data.ecommerce.shipping_tier = payload.shippingOption;
		}

		if(['add_payment_info'].includes(event)) {
			data.ecommerce.payment_type = payload.paymentOption;
		}

		if(['purchase'].includes(event)) {
			data.ecommerce.value = formatPrice(payload.value);
			data.ecommerce.tax = formatPrice(payload.tax);
			data.ecommerce.shipping = formatPrice(payload.shipping);
			data.ecommerce.transaction_id = payload.transaction_id;
			data.ecommerce.coupon = payload.coupon || '';
			productExtraData.coupon = payload.coupon || '';
		}

		if(['view_promotion', 'select_promotion'].includes(event)) {
			data.ecommerce = {
				promotion_id: payload.promotion_id || '',
				promotion_name: payload.promotion_name || '',
				creative_name: payload.creative_name || '',
				creative_slot: payload.creative_slot || '',
				items: [],
			};
		}

		if(!['virtualPageview'].includes(event) && payload.items) data.ecommerce.items = mapProducts(payload.items, productExtraData);

		_pushToDataLayer(data);
	}

	//get products
	function mapProducts(products, extraData = {}) {
		if (!products) {
			console.log('Products not provided', 'error');
			return [];
		}

		// Convert single product to array
		if (!Array.isArray(products)) products = [products];

		return products.map((product, index) => {
			let price = 0;
			let discount = 0;
			let variant = '';
			let categoryTitle = product.category_title || '';
			let categoryCode = product.category_code || '';

			const categories = {};
			if (product.category_parents?.length) {
				product.category_parents.forEach((category, index) => {
					categories[`item_category${index + 2}`] = category.title;
				});
			}

			// Regular product data
			if (product.discount_percent_custom && product.basic_price_custom) {
				discount = product.basic_price_custom - product.price_custom;
			}
			if (product.price_custom) price = product.price_custom;
			if (product.variation?.attributes) variant = product.variation.attributes;

			// Cart data
			if (product.item) {
				if (product.discount_amount) discount = product.discount_amount;
				if (product.unit_price) price = product.unit_price;
				if (product.item?.variation?.attributes) variant = product.item.variation.attributes;
				if (product.item?.category?.title) categoryTitle = product.item.category.title;
				if (product.item?.category?.code) categoryCode = product.item.category.code;
			}

			const productData = {
				affiliation: product.seller_title || '',
				discount: formatPrice(discount),
				item_id: product.item?.id || product.id || '',
				item_code: product.item?.code || product.code || '',
				item_name: product.item?.title || product.title || '',
				index: index + 1,
				item_brand: product.item?.manufacturer?.title || product.manufacturer_title || '',
				item_list_name: product.item_list_name || categoryTitle || '',
				item_list_id: product.item_list_id || categoryCode || '',
				item_category: product.item?.category?.title || categoryTitle || '',
				price: formatPrice(price),
				quantity: product.quantity || 1,
				...categories,
				...extraData,
			};

			return productData;
		});
	}

	function getCartProducts(cart) {
		let products = [];
		if (cart.parcels?.length) {
			const cartItems = storage.get('gtm_cart_items');

			cart.parcels.forEach(parcel => {
				if(parcel.items) {
					parcel.items.forEach(item => {
						if(cartItems) {
							const storageItem = cartItems.find(cartItem => cartItem.shopping_cart_code === item.shopping_cart_code);
							if(storageItem) {
								item.item_list_id = storageItem.item_list_id;
								item.item_list_name = storageItem.item_list_name;
							}
						}
						products.push(item);
					});
				}
			});

			// Clear localStorage if there are no products in the cart. Leave only products that are in the cart.
			if (products.length === 0) {
				storage.remove('gtm_cart_items');
			} else {
				const cartItemsToKeep = cartItems?.filter(item => products.some(product => product.shopping_cart_code === item.shopping_cart_code));
				if(cartItemsToKeep?.length) storage.create('gtm_cart_items', cartItemsToKeep);
			}
		}
		return products;
	}

	function waitForWindowAndExecute(action, interval = 1000, timeout = 20000) {
		let elapsedTime = 0;

		function checkWindow() {
			if (typeof window !== 'undefined' && typeof window?.dataLayer !== 'undefined' && window?.google_tag_manager?.dataLayer?.gtmDom === true && window?.google_tag_manager?.dataLayer?.gtmLoad === true) {
				// Execute action only when dataLayer is loaded and both gtmDom and gtmLoad are true
				action();
			} else if (elapsedTime < timeout) {
				elapsedTime += interval;
				setTimeout(checkWindow, interval);
			}
		}

		checkWindow();
	}

	function _pushToDataLayer(data) {
		waitForWindowAndExecute(
			() => {
				if (window?.dataLayer) {
					dataLayer.push(data);
					//console.log(data.event, data);
				}
			},
			1000,
			20000
		); // Interval of 1000ms and timeout of 20000ms (20 seconds)
	}

	function removeProtocol(url) {
		return url.replace(/^https?:\/\//, '');
	}

	function formatTotalPrice(payload) {
		let price = 0;
		let quantity = 1;

		if (Array.isArray(payload.items)) {
			return payload.items.reduce((total, item) => {
				price = item.price_custom || item.unit_price;
				quantity = payload.quantity || item.quantity || 1;
				return formatPrice(total + price * quantity);
			}, 0);
		}
		price = payload.items.price_custom || payload.items.unit_price;
		quantity = payload.quantity || payload.items.quantity || 1;
		return formatPrice(price * quantity);
	}

	function formatPrice(price) {
		let p = parseFloat(price).toFixed(2);
		return parseFloat(p);
	}

	function stringifyAttributes(attributes) {
		if (!attributes) return '';
		return Object.values(attributes)
			.map(attr => {
				return `${attr.attribute_title}:${attr.title}`;
			})
			.join(',');
	}

	return {
		sendReferral,
		gtmTrack,
	};
}
